export default {
      id: "phone-circle-usage",
      viewBox: "0 0 122.88 122.88",
      url: __webpack_public_path__ + "img/icons.svg#phone-circle",
      toString: function () {
        return this.url;
      }
    }